import { useRef } from 'react';
import { useForceUpdate } from './useForceUpdate';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
import { useStableCallback } from './useStableCallback';
export function useElementSize(element, callback, property = 'contentRect') {
    const observer = useRef();
    const forceUpdate = useForceUpdate();
    const previouslyUsedElement = useRef(null);
    // need to typecast this as the union is messing up when being called
    const stableCallback = useStableCallback(callback);
    useIsomorphicLayoutEffect(() => {
        observer.current = new ResizeObserver(([entry]) => {
            window.requestAnimationFrame(() => {
                const entryProperty = entry[property];
                const [size] = Array.isArray(entryProperty)
                    ? entryProperty
                    : [entryProperty || entry.contentRect];
                stableCallback(size, entry.target);
            });
        });
        return () => {
            var _a;
            (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
    }, []);
    useIsomorphicLayoutEffect(() => {
        const usedElement = element &&
            !(element instanceof HTMLElement || element instanceof SVGElement)
            ? element.current
            : element;
        if (usedElement && previouslyUsedElement.current !== usedElement) {
            forceUpdate();
        }
        if (usedElement) {
            previouslyUsedElement.current = usedElement;
        }
    });
    useIsomorphicLayoutEffect(() => {
        var _a;
        const usedElement = element &&
            !(element instanceof HTMLElement || element instanceof SVGElement)
            ? element.current
            : element;
        if (!usedElement)
            return;
        (_a = observer.current) === null || _a === void 0 ? void 0 : _a.observe(usedElement);
        return () => {
            var _a;
            (_a = observer.current) === null || _a === void 0 ? void 0 : _a.unobserve(usedElement);
        };
    }, [element, previouslyUsedElement.current]);
}
//# sourceMappingURL=useElementSize.js.map